import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';

import Set from './components/set/Set';
import { addSwitchPurpose, removeSwitchPurpose } from '../../../redux/actions/switches';
import { addUserPurpose, removeUserPurpose } from '../../../redux/actions/consent';

const SectionStyled = styled.div`
    padding: 40px;

    @media screen and (max-width: 600px) {
        padding: 15px;
    }
`;

const mapPropsToState = state => ({
    switches: state.switches,
    list: state.language === 'en' ? state.vendorList.list : state.translatedList.list,
    customList: state.customPurposesList.list,
});

const mapDispatchToProps = (dispatch) => {
    return {
        add: (id) => dispatch(addSwitchPurpose(id)),
        remove: (id) => dispatch(removeSwitchPurpose(id)),
        addPurpose: (id) => dispatch(addUserPurpose(id)),
        removePurpose: (id) => dispatch(removeUserPurpose(id)),
    }
};

const Settings = ({
    switches,list, customList,
    add, remove, addPurpose, removePurpose
}) => {

    const transitionTime = 400;
    const [inProps, setInProps] = useState(false);
    const purposes = list.purposes.map((e, i) => Object.assign({}, e, switches.purposes[i]));
    const customs = customList.purposes.map((e, i) => Object.assign({}, e, switches.custom[i]));

    useEffect(() => {
        setInProps(true);
        return () => setInProps(false)
    }, []);

    return (
        <CSSTransition
            in={inProps}
            timeout={{ enter: transitionTime, exit: transitionTime }}
            unmountOnExit
            classNames="s-gdpr__effect">
            <SectionStyled>

                <Set
                    list={customs}
                    addPurpose={addPurpose}
                    removePurpose={removePurpose}
                    add={add}
                    remove={remove}
                    title='Цели'>
                </Set>

                <Set
                    list={purposes}
                    addPurpose={addPurpose}
                    removePurpose={removePurpose}
                    add={add}
                    remove={remove}>
                </Set>

            </SectionStyled>
        </CSSTransition>
    );
};

export default connect(mapPropsToState, mapDispatchToProps)(Settings);